import { useEffect } from 'react';
import * as mapbox from 'mapbox-gl';
import * as turf from '@turf/turf';

export const useMapRadius = (
    map: mapbox.Map,
    lat: number,
    lng: number,
    radius: number,
) => {
    useEffect(() => {
        const createCircle = () => {
            const brandColor = getComputedStyle(document.documentElement).getPropertyValue('--brandColor');

            const circle = turf.circle(
                turf.point([lng, lat]),
                radius,
                { units: 'meters' }
            );

            console

            map.addSource("circleData", {
                type: "geojson",
                data: circle,
            });

            map.addLayer({
                id: "circle-fill",
                type: "fill",
                source: "circleData",
                paint: {
                    "fill-color": brandColor,
                    "fill-opacity": 0.1,
                },
            });
        };

        map.on('load', () => {
            createCircle();
        });
    }, [map, lat, lng]);
};
